<template>
    <div>
      <b-modal
        class="modal-widget"
        v-model="show"
        @hidden="onHidden"
        :title="title"
        size="lg"
        header-bg-variant="primary">
        <b-container fluid>
          <b-form @submit.prevent="onSubmit">
            <div class="form-row">
              <div v-show="!isEdit" class="form-group col-md-12">
                <multiselect
                  name="dashboard_name"
                  v-validate="'required'"
                  :class="{'multiselect-danger': errors.has('dashboard_name')}"
                  v-model="selectedWidget"
                  :options="widgetOptions"
                  label="title"
                  track-by="name"
                  placeholder="Select widget">
                  <template slot="option" slot-scope="props">
                    <i v-if="props.option.iconClass" :class="props.option.iconClass"></i> {{props.option.title}}
                  </template>
                </multiselect>
              </div>
              <template v-if="hasSelectWidget">
                <div class="form-group col-md-12">
                  <label for="widget_title">Widget Title</label>
                  <input
                    v-model="form.title"
                    type="text"
                    placeholder="Enter title"
                    class="form-control"
                    id="widget_title">
                </div>
                <template v-for="option in selectorOptions">
                  <div v-if="option.type === 'date_range'"
                    class="form-group col-md-12"
                    :key="option.type">
                    <span>Date Range</span>
                    <multiselect
                      name="date_range"
                      v-validate="option.type === 'date_range' ? 'required' : ''"
                      :class="{'multiselect-danger': errors.has('date_range')}"
                      v-model="selectedDaterange"
                      label="name"
                      class="mt-2 preset-range"
                      track-by="value"
                      :options="presetsDaterange"></multiselect>
                    <date-picker
                      v-if="isSelectCustomDate"
                      v-model="customDate"
                      lang="en"
                      :editable="false"
                      :clearable="false"
                      :shortcuts="false"
                      range-separator="to"
                      format="YYYY-MM-DD" range></date-picker>
                  </div>
                  <div v-if="option.type === 'geofences'"
                    class="form-group col-md-12"
                    :key="option.type">
                    <span>Select Geofences</span>
                    <multiselect
                      name="geofences"
                      :multiple=true
                      v-validate="option.type === 'geofences' ? 'required' : ''"
                      :class="{'multiselect-danger': errors.has('geofences')}"
                      v-model="selectedGeofences"
                      label="name"
                      class="mt-2"
                      track-by="id"
                      :options="geofences"></multiselect>
                    </div>
                </template>
              </template>
            </div>
          </b-form>
        </b-container>
        <div slot="modal-footer" class="w-100">
          <b-button size="md" class="float-right" variant="primary" @click="onSubmit">
            Submit
          </b-button>
          <b-button style="margin-right: 5px;" size="md" class="float-right" variant="warning" @click="onShow(false)">
            Close
          </b-button>
        </div>
      </b-modal>
    </div>
</template>
<script>
import dashboardMixin from '@/mixins/dashboard';
import Multiselect from 'vue-multiselect';
import { sortBy, isEmpty, find, isUndefined } from 'lodash';
import DatePicker from 'vue2-datepicker';
import { format } from 'date-fns';
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'create_edit_widget',
  mixins: [dashboardMixin],
  components: {
    Multiselect,
    DatePicker,
  },
  data() {
    return {
      show: false,
      selectedWidget: null,
      selectorOptions: [],
      selectedDaterange: null,
      customDate: null,
      selectedGeofences: [],
      form: {
        name: null,
        title: null,
        options: [],
      },
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
      require: true,
    },
    widgetItems: {
      type: Array,
      require: true,
    },
    editWidget: {
      type: Object,
    },
  },
  created() {
    this.$store.dispatch('shipment_md/shipments/LOAD_LOCATIONS');
  },
  computed: {
    widgetOptions() {
      return sortBy(this.widgetList, ['title']);
    },
    hasSelectWidget() {
      return !isEmpty(this.selectedWidget);
    },
    isEdit() {
      return !isEmpty(this.editWidget);
    },
    title() {
      return this.isEdit ? 'Update Widget' : 'Create Widget';
    },
    isSelectCustomDate() {
      if (isEmpty(this.selectedDaterange)) {
        return false;
      }

      return this.selectedDaterange.value === 'custom';
    },
    geofences() {
      return this.$store.getters['shipment_md/shipments/locations'];
    },
  },
  watch: {
    selectedWidget(wg) {
      if (!isEmpty(wg)) {
        const { form } = this;
        const {
          options, name, title, minW, minH, h, i, x, y, iconClass,
        } = wg;

        form.i = i;
        form.x = x;
        form.y = y;
        form.name = name;
        form.title = title;
        form.minW = minW;
        form.w = minW;
        form.minH = minH;
        form.h = isUndefined(h) ? minH : h;
        form.options = options;
        form.iconClass = iconClass;

        const hasDaterange = Object.prototype.hasOwnProperty.call(wg, 'date_range');
        const hasGeofences = Object.prototype.hasOwnProperty.call(wg, 'geofences');

        if (hasDaterange) {
          const isCustom = wg.date_range === 'custom';
          if (isCustom) {
            const { start_date, end_date } = wg;

            form.start_date = start_date;
            form.end_date = end_date;
            this.customDate = [new Date(start_date), new Date(end_date)];
          }
        }
        if (hasGeofences) {
          form.geofences = wg.geofences;
          this.selectedGeofences = wg.geofences;
        }

        this.selectorOptions.splice(0);
        options.forEach((op) => {
          this.selectorOptions.push(op);
          if (op.type === 'date_range') {
            this.selectedDaterange = find(this.presetsDaterange, { value: wg.date_range });
          }
        });
      }
    },
    selectedDaterange(range) {
      if (!isEmpty(range)) {
        const { form } = this;
        form.date_range = range.value;

        if (isEmpty(this.customDate)) {
          this.customDate = [new Date(), new Date()];
        }

        if (range.value !== 'custom') {
          const { start_date, end_date } = this.updateRange(range.value);
          form.start_date = start_date;
          form.end_date = end_date;
        }
      }
    },
    selectedGeofences(geofences) {
      if (!isEmpty(geofences)) {
        const { form } = this;
        form.geofences = geofences.map(geo => ({ id: geo.id, name: geo.name }));
      }
    },
    editWidget(w) {
      this.selectedWidget = w;
    },
    showModal(show) {
      this.show = show;
    },
    customDate(date) {
      if (!isEmpty(date)) {
        const { form } = this;
        form.start_date = format(date[0], 'YYYY-MM-DD');
        form.end_date = format(date[1], 'YYYY-MM-DD');
      }
    },
  },
  methods: {
    onShow(value) {
      if (value === false) {
        this.selectedWidget = null;
        this.customDate = null;
        this.selectedGeofences = [];
      }
      this.$emit('on-show', value);
    },
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          let updatedWidgets = this.widgetItems;

          if (!this.isEdit) {
            this.form.i = `${Date.now()}-wg`;
            this.form.x = 0;
            this.form.y = 100;
            updatedWidgets.push(this.form);
          } else {
            updatedWidgets = this.widgetItems.map((w) => {
              if (this.form.i === w.i) { return this.form; }
              return w;
            });
          }
          updatedWidgets = this.parsePreference(updatedWidgets, 'toString');

          setTimeout(() => {
            const ds = { dashboard: updatedWidgets };
            this.$store.dispatch('dashboard/UPDATE_USER_PREFERENCES', ds).then(() => {
              this.onShow(false);
              if (!this.isEdit) {
                VueScrollTo.scrollTo('.app-footer', 3e3, {
                  container: 'body',
                  easing: 'ease-in',
                });
              }
              this.$emit('on-submited');
            });
          }, 1e2);
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onHidden() {
      this.onShow(false);
    },
  },
};
</script>
<style lang="sass">
@import "~vue-multiselect/dist/vue-multiselect.min"
.multiselect-danger .multiselect__tags
  border: 1px solid #f86c6b
.preset-range
  margin-bottom: 10px;
.modal-widget
  .multiselect
    z-index: 0
  .multiselect--active
    z-index: 9999
  .multiselect--active
    .multiselect__content-wrapper
      z-index: 9999 !important
</style>



// WEBPACK FOOTER //
// src/views/pages/dashboard/CreateEdit.vue